module.exports = __webpack_public_path__ + "static/media/highschool-student-male-caucasian.ed597b70.png";